import { OptionTypeBase, StylesConfig } from 'react-select';

export const DropdownStyles: StylesConfig<OptionTypeBase, false> = {
  control: (styles) => ({
    ...styles,
    borderWidth: 0,
    boxShadow: 'none',
    ':hover': {
      borderWidth: 0,
      borderColor: 'transparent',
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: 0,
    fontFamily: 'NunitoSans-Medium',
  }),
  singleValue: (styles) => ({
    ...styles,
    fontFamily: 'NunitoSans-Medium',
    fontWeight: 500,
  }),
};
